module.exports = __webpack_public_path__ + "img/Weapon_248.b08b9cd4.png";